export const cloneErrors = ({ name, price, requirePrice = false }) => {
  const errors = {};
  if (!name?.trim()) errors.name = "Name is required";
  if (requirePrice && (price === "" || price === null || price === undefined)) {
    errors.price = "Buyer price is required for another rung";
  }
  if (price !== "" && price !== null && price !== undefined) {
    const value = Number(price);
    if (!Number.isFinite(value) || value <= 0 || value > 10000 ||
        !/^\d+(\.\d{1,2})?$/.test(String(price))) {
      errors.price = "Buyer price must be greater than 0, at most 10000, with up to 2 decimals";
    }
  }
  return errors;
};

export const cloneRequest = ({ name, price }) => ({
  data: {
    name: name.trim(),
    ...(price === "" || price === null || price === undefined ? {} : { price: Number(price) }),
  },
});
